/* tslint:disable */
/* eslint-disable */
/**
 * Ticket enforcement
 * Le service ticket enforcement permet la création et la mise à jour d\'un ticket, et le contrôle d\'un droit.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface Docs
 */
export interface Docs {
    /**
     * 
     * @type {Array<Ticket>}
     * @memberof Docs
     */
    'docs'?: Array<Ticket>;
}
/**
 * 
 * @export
 * @interface Ticket
 */
export interface Ticket {
    /**
     * Identifiant unique du ticket en base de donnée
     * @type {string}
     * @memberof Ticket
     */
    '_id'?: string;
    /**
     * Révision du document
     * @type {string}
     * @memberof Ticket
     */
    '_rev'?: string;
    /**
     * 
     * @type {string}
     * @memberof Ticket
     */
    'profile': TicketProfileEnum;
    /**
     * Code tariffaire de validité du ticket.
     * @type {string}
     * @memberof Ticket
     */
    'tariffCode'?: string;
    /**
     * Lieux de résidence de validité du ticket.
     * @type {string}
     * @memberof Ticket
     */
    'locationCode'?: string;
    /**
     * Identifiant de l\'opérateur.
     * @type {number}
     * @memberof Ticket
     */
    'operatorId': number;
    /**
     * Identifiant unique du ticket.
     * @type {string}
     * @memberof Ticket
     */
    'systemId': string;
    /**
     * Plaque d\'immatriculation associé au ticket.
     * @type {string}
     * @memberof Ticket
     */
    'licensePlate'?: string;
    /**
     * Plaque d\'immatriculation associé au ticket.
     * @type {string}
     * @memberof Ticket
     */
    'licensePlateHash'?: string;
    /**
     * Date de début du ticket.
     * @type {string}
     * @memberof Ticket
     */
    'startDateTime': string;
    /**
     * Date de fin du ticket.
     * @type {string}
     * @memberof Ticket
     */
    'endDateTime': string;
    /**
     * Date de creation du ticket.
     * @type {string}
     * @memberof Ticket
     */
    'createdAt': string;
    /**
     * Durré du ticket.
     * @type {number}
     * @memberof Ticket
     */
    'paidMinutes': number;
    /**
     * Montant du ticket (en centimes dans le cas ou amountCurrency a la valeur EUR)
     * @type {number}
     * @memberof Ticket
     */
    'amountPaid': number;
    /**
     * 
     * @type {string}
     * @memberof Ticket
     */
    'amountCurrency': string;
    /**
     * Indique si le ticket est à prendre en compte lors du calcul du montant du FPS
     * @type {boolean}
     * @memberof Ticket
     */
    'isSignificant': boolean;
}

export const TicketProfileEnum = {
    VIS: 'VIS',
    FPS: 'FPS',
    PMR: 'PMR',
    RES: 'RES',
    PRO_M: 'PRO-M',
    PRO_S: 'PRO-S',
    PRO_P: 'PRO-P',
    VP: 'VP'
} as const;

export type TicketProfileEnum = typeof TicketProfileEnum[keyof typeof TicketProfileEnum];

/**
 * 
 * @export
 * @interface TicketVerifyResult
 */
export interface TicketVerifyResult {
    /**
     * 
     * @type {TicketVerifyResultParameters}
     * @memberof TicketVerifyResult
     */
    'parameters'?: TicketVerifyResultParameters;
    /**
     * Date a laquelle le contrôle est valide.
     * @type {string}
     * @memberof TicketVerifyResult
     */
    'scandate'?: string;
    /**
     * Validité du droit au moment du contrôle.
     * @type {string}
     * @memberof TicketVerifyResult
     */
    'status'?: TicketVerifyResultStatusEnum;
    /**
     * 
     * @type {Array<Ticket>}
     * @memberof TicketVerifyResult
     */
    'results'?: Array<Ticket>;
}

export const TicketVerifyResultStatusEnum = {
    INVALID: 'INVALID',
    VALID: 'VALID'
} as const;

export type TicketVerifyResultStatusEnum = typeof TicketVerifyResultStatusEnum[keyof typeof TicketVerifyResultStatusEnum];

/**
 * 
 * @export
 * @interface TicketVerifyResultParameters
 */
export interface TicketVerifyResultParameters {
    /**
     * Plaque d\'immatriculation sur laquelle le contrôle a été effectué.
     * @type {string}
     * @memberof TicketVerifyResultParameters
     */
    'licensePlate'?: string;
    /**
     * Latitude à laquelle le contrôle a été effectué.
     * @type {number}
     * @memberof TicketVerifyResultParameters
     */
    'latitude'?: number;
    /**
     * Longitude à laquelle le contrôle a été effectué.
     * @type {number}
     * @memberof TicketVerifyResultParameters
     */
    'longitude'?: number;
    /**
     * Précision autour de laqulle le contôle est valide (en mètre).
     * @type {number}
     * @memberof TicketVerifyResultParameters
     */
    'accuracy'?: number;
    /**
     * Date a laquelle le contrôle est valide.
     * @type {string}
     * @memberof TicketVerifyResultParameters
     */
    'scandate'?: string;
    /**
     * 
     * @type {string}
     * @memberof TicketVerifyResultParameters
     */
    'terminalType'?: TicketVerifyResultParametersTerminalTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof TicketVerifyResultParameters
     */
    'matricule'?: string;
    /**
     * 
     * @type {TicketVerifyResultParametersExtraProperties}
     * @memberof TicketVerifyResultParameters
     */
    'extraProperties'?: TicketVerifyResultParametersExtraProperties;
}

export const TicketVerifyResultParametersTerminalTypeEnum = {
    PDA: 'PDA',
    IMAGE_REVIEW: 'IMAGE_REVIEW',
    LAPI: 'LAPI'
} as const;

export type TicketVerifyResultParametersTerminalTypeEnum = typeof TicketVerifyResultParametersTerminalTypeEnum[keyof typeof TicketVerifyResultParametersTerminalTypeEnum];

/**
 * 
 * @export
 * @interface TicketVerifyResultParametersExtraProperties
 */
export interface TicketVerifyResultParametersExtraProperties {
    /**
     * 
     * @type {string}
     * @memberof TicketVerifyResultParametersExtraProperties
     */
    'vehicleType'?: string;
}
/**
 * 
 * @export
 * @interface WhitelistDeleteReq
 */
export interface WhitelistDeleteReq {
    /**
     * 
     * @type {string}
     * @memberof WhitelistDeleteReq
     */
    'id'?: string;
    /**
     * 
     * @type {WhitelistUpdateReqUser}
     * @memberof WhitelistDeleteReq
     */
    'user'?: WhitelistUpdateReqUser;
}
/**
 * 
 * @export
 * @interface WhitelistDeleteRes
 */
export interface WhitelistDeleteRes {
    /**
     * 
     * @type {Array<string>}
     * @memberof WhitelistDeleteRes
     */
    'delted'?: Array<string>;
    /**
     * 
     * @type {Array<object>}
     * @memberof WhitelistDeleteRes
     */
    'errors'?: Array<object>;
}
/**
 * 
 * @export
 * @interface WhitelistEntry
 */
export interface WhitelistEntry {
    /**
     * 
     * @type {string}
     * @memberof WhitelistEntry
     */
    'plate'?: string;
    /**
     * 
     * @type {string}
     * @memberof WhitelistEntry
     */
    'start'?: string;
    /**
     * 
     * @type {string}
     * @memberof WhitelistEntry
     */
    'end'?: string;
    /**
     * 
     * @type {string}
     * @memberof WhitelistEntry
     */
    'service'?: string;
}
/**
 * 
 * @export
 * @interface WhitelistUpdateReq
 */
export interface WhitelistUpdateReq {
    /**
     * 
     * @type {string}
     * @memberof WhitelistUpdateReq
     */
    'plate'?: string;
    /**
     * 
     * @type {string}
     * @memberof WhitelistUpdateReq
     */
    'start'?: string;
    /**
     * 
     * @type {string}
     * @memberof WhitelistUpdateReq
     */
    'end'?: string;
    /**
     * 
     * @type {string}
     * @memberof WhitelistUpdateReq
     */
    'service'?: string;
    /**
     * 
     * @type {string}
     * @memberof WhitelistUpdateReq
     */
    'id'?: string;
    /**
     * 
     * @type {WhitelistUpdateReqUser}
     * @memberof WhitelistUpdateReq
     */
    'user'?: WhitelistUpdateReqUser;
}
/**
 * 
 * @export
 * @interface WhitelistUpdateReqUser
 */
export interface WhitelistUpdateReqUser {
    /**
     * 
     * @type {string}
     * @memberof WhitelistUpdateReqUser
     */
    'matricule'?: string;
    /**
     * 
     * @type {string}
     * @memberof WhitelistUpdateReqUser
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface WhitelistUpdateRes
 */
export interface WhitelistUpdateRes {
    /**
     * 
     * @type {Array<string>}
     * @memberof WhitelistUpdateRes
     */
    'updated'?: Array<string>;
    /**
     * 
     * @type {Array<object>}
     * @memberof WhitelistUpdateRes
     */
    'errors'?: Array<object>;
}

/**
 * TicketApi - axios parameter creator
 * @export
 */
export const TicketApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * La route permet d\'effectuer un contrôle de stationnement. La route retourne la validité du droit dans le champ status, ainsi que la liste des tickets pertinent dans le cadre du contrôle.<br/> Dans le cas ou le droit est valide, le champ status prend la valeur VALID, et les tickets justifiant le droit sont retournés.<br/> Dans le cas ou le droit est invalide, le champ status prend la valeur INVALID. La route peut également renvoyer les tickets qui seront utilisés dans le cadre du calcul du montant du FPS lors de la verbalisation.<br/> Les droits necessaires dans le JWT sont  &#58; <ul> <il><b>ROLE_TICKETS_VERIFY</b></il> </ul>
         * @summary Controle de stationnement.
         * @param {string} cityId siret de la ville
         * @param {string} licensePlate Plaque d\&#39;immatriculation sur laquelle effectuer le contrôle.
         * @param {number} [latitude] Latitude du contrôle.
         * @param {number} [longitude] Longitude du contrôle.
         * @param {number} [accuracy] Précision du contrôle en mètres. Cette valeur peut être arbitraire, elle permet de récupérer les tickets sur des zones voisines lorsque le contrôle est effectué sur une frontière.
         * @param {string} [scandate] Date du contrôle (ISO 8601). Si la valeur n\&#39;est pas spécifiée, la date courante est appliquée.
         * @param {'PDA' | 'IMAGE_REVIEW' | 'LAPI'} [terminalType] 
         * @param {string} [matricule] 
         * @param {string} [requestSrc] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTicketControl: async (cityId: string, licensePlate: string, latitude?: number, longitude?: number, accuracy?: number, scandate?: string, terminalType?: 'PDA' | 'IMAGE_REVIEW' | 'LAPI', matricule?: string, requestSrc?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cityId' is not null or undefined
            assertParamExists('getTicketControl', 'cityId', cityId)
            // verify required parameter 'licensePlate' is not null or undefined
            assertParamExists('getTicketControl', 'licensePlate', licensePlate)
            const localVarPath = `/{cityId}/tickets`
                .replace(`{${"cityId"}}`, encodeURIComponent(String(cityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-bearer-token", configuration)

            if (licensePlate !== undefined) {
                localVarQueryParameter['licensePlate'] = licensePlate;
            }

            if (latitude !== undefined) {
                localVarQueryParameter['latitude'] = latitude;
            }

            if (longitude !== undefined) {
                localVarQueryParameter['longitude'] = longitude;
            }

            if (accuracy !== undefined) {
                localVarQueryParameter['accuracy'] = accuracy;
            }

            if (scandate !== undefined) {
                localVarQueryParameter['scandate'] = (scandate as any instanceof Date) ?
                    (scandate as any).toISOString().substr(0,10) :
                    scandate;
            }

            if (terminalType !== undefined) {
                localVarQueryParameter['terminalType'] = terminalType;
            }

            if (matricule !== undefined) {
                localVarQueryParameter['matricule'] = matricule;
            }

            if (requestSrc !== undefined) {
                localVarQueryParameter['requestSrc'] = requestSrc;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Les droits necessaires dans le JWT sont &#58; <ul> <il><b>API_DISPATCHER_TICKET_WRITE</b></il> </ul>
         * @summary Sauvegarde d\'un ou plusieurs ticket
         * @param {string} cityId siret de la ville
         * @param {Docs} body 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        insertTicket: async (cityId: string, body: Docs, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cityId' is not null or undefined
            assertParamExists('insertTicket', 'cityId', cityId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('insertTicket', 'body', body)
            const localVarPath = `/{cityId}/tickets`
                .replace(`{${"cityId"}}`, encodeURIComponent(String(cityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-bearer-token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Les droits necessaires dans le JWT sont &#58; <ul> <il><b>API_DISPATCHER_TICKET_WRITE</b></il> </ul>
         * @summary Mise à jour d\'un ou plusieurs tickets
         * @param {string} cityId siret de la ville
         * @param {Docs} body 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        updateTicket: async (cityId: string, body: Docs, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cityId' is not null or undefined
            assertParamExists('updateTicket', 'cityId', cityId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('updateTicket', 'body', body)
            const localVarPath = `/{cityId}/tickets`
                .replace(`{${"cityId"}}`, encodeURIComponent(String(cityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-bearer-token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TicketApi - functional programming interface
 * @export
 */
export const TicketApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TicketApiAxiosParamCreator(configuration)
    return {
        /**
         * La route permet d\'effectuer un contrôle de stationnement. La route retourne la validité du droit dans le champ status, ainsi que la liste des tickets pertinent dans le cadre du contrôle.<br/> Dans le cas ou le droit est valide, le champ status prend la valeur VALID, et les tickets justifiant le droit sont retournés.<br/> Dans le cas ou le droit est invalide, le champ status prend la valeur INVALID. La route peut également renvoyer les tickets qui seront utilisés dans le cadre du calcul du montant du FPS lors de la verbalisation.<br/> Les droits necessaires dans le JWT sont  &#58; <ul> <il><b>ROLE_TICKETS_VERIFY</b></il> </ul>
         * @summary Controle de stationnement.
         * @param {string} cityId siret de la ville
         * @param {string} licensePlate Plaque d\&#39;immatriculation sur laquelle effectuer le contrôle.
         * @param {number} [latitude] Latitude du contrôle.
         * @param {number} [longitude] Longitude du contrôle.
         * @param {number} [accuracy] Précision du contrôle en mètres. Cette valeur peut être arbitraire, elle permet de récupérer les tickets sur des zones voisines lorsque le contrôle est effectué sur une frontière.
         * @param {string} [scandate] Date du contrôle (ISO 8601). Si la valeur n\&#39;est pas spécifiée, la date courante est appliquée.
         * @param {'PDA' | 'IMAGE_REVIEW' | 'LAPI'} [terminalType] 
         * @param {string} [matricule] 
         * @param {string} [requestSrc] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTicketControl(cityId: string, licensePlate: string, latitude?: number, longitude?: number, accuracy?: number, scandate?: string, terminalType?: 'PDA' | 'IMAGE_REVIEW' | 'LAPI', matricule?: string, requestSrc?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TicketVerifyResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTicketControl(cityId, licensePlate, latitude, longitude, accuracy, scandate, terminalType, matricule, requestSrc, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Les droits necessaires dans le JWT sont &#58; <ul> <il><b>API_DISPATCHER_TICKET_WRITE</b></il> </ul>
         * @summary Sauvegarde d\'un ou plusieurs ticket
         * @param {string} cityId siret de la ville
         * @param {Docs} body 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async insertTicket(cityId: string, body: Docs, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Docs>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.insertTicket(cityId, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Les droits necessaires dans le JWT sont &#58; <ul> <il><b>API_DISPATCHER_TICKET_WRITE</b></il> </ul>
         * @summary Mise à jour d\'un ou plusieurs tickets
         * @param {string} cityId siret de la ville
         * @param {Docs} body 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async updateTicket(cityId: string, body: Docs, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTicket(cityId, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TicketApi - factory interface
 * @export
 */
export const TicketApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TicketApiFp(configuration)
    return {
        /**
         * La route permet d\'effectuer un contrôle de stationnement. La route retourne la validité du droit dans le champ status, ainsi que la liste des tickets pertinent dans le cadre du contrôle.<br/> Dans le cas ou le droit est valide, le champ status prend la valeur VALID, et les tickets justifiant le droit sont retournés.<br/> Dans le cas ou le droit est invalide, le champ status prend la valeur INVALID. La route peut également renvoyer les tickets qui seront utilisés dans le cadre du calcul du montant du FPS lors de la verbalisation.<br/> Les droits necessaires dans le JWT sont  &#58; <ul> <il><b>ROLE_TICKETS_VERIFY</b></il> </ul>
         * @summary Controle de stationnement.
         * @param {string} cityId siret de la ville
         * @param {string} licensePlate Plaque d\&#39;immatriculation sur laquelle effectuer le contrôle.
         * @param {number} [latitude] Latitude du contrôle.
         * @param {number} [longitude] Longitude du contrôle.
         * @param {number} [accuracy] Précision du contrôle en mètres. Cette valeur peut être arbitraire, elle permet de récupérer les tickets sur des zones voisines lorsque le contrôle est effectué sur une frontière.
         * @param {string} [scandate] Date du contrôle (ISO 8601). Si la valeur n\&#39;est pas spécifiée, la date courante est appliquée.
         * @param {'PDA' | 'IMAGE_REVIEW' | 'LAPI'} [terminalType] 
         * @param {string} [matricule] 
         * @param {string} [requestSrc] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTicketControl(cityId: string, licensePlate: string, latitude?: number, longitude?: number, accuracy?: number, scandate?: string, terminalType?: 'PDA' | 'IMAGE_REVIEW' | 'LAPI', matricule?: string, requestSrc?: string, options?: any): AxiosPromise<TicketVerifyResult> {
            return localVarFp.getTicketControl(cityId, licensePlate, latitude, longitude, accuracy, scandate, terminalType, matricule, requestSrc, options).then((request) => request(axios, basePath));
        },
        /**
         * Les droits necessaires dans le JWT sont &#58; <ul> <il><b>API_DISPATCHER_TICKET_WRITE</b></il> </ul>
         * @summary Sauvegarde d\'un ou plusieurs ticket
         * @param {string} cityId siret de la ville
         * @param {Docs} body 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        insertTicket(cityId: string, body: Docs, options?: any): AxiosPromise<Docs> {
            return localVarFp.insertTicket(cityId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * Les droits necessaires dans le JWT sont &#58; <ul> <il><b>API_DISPATCHER_TICKET_WRITE</b></il> </ul>
         * @summary Mise à jour d\'un ou plusieurs tickets
         * @param {string} cityId siret de la ville
         * @param {Docs} body 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        updateTicket(cityId: string, body: Docs, options?: any): AxiosPromise<void> {
            return localVarFp.updateTicket(cityId, body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TicketApi - interface
 * @export
 * @interface TicketApi
 */
export interface TicketApiInterface {
    /**
     * La route permet d\'effectuer un contrôle de stationnement. La route retourne la validité du droit dans le champ status, ainsi que la liste des tickets pertinent dans le cadre du contrôle.<br/> Dans le cas ou le droit est valide, le champ status prend la valeur VALID, et les tickets justifiant le droit sont retournés.<br/> Dans le cas ou le droit est invalide, le champ status prend la valeur INVALID. La route peut également renvoyer les tickets qui seront utilisés dans le cadre du calcul du montant du FPS lors de la verbalisation.<br/> Les droits necessaires dans le JWT sont  &#58; <ul> <il><b>ROLE_TICKETS_VERIFY</b></il> </ul>
     * @summary Controle de stationnement.
     * @param {string} cityId siret de la ville
     * @param {string} licensePlate Plaque d\&#39;immatriculation sur laquelle effectuer le contrôle.
     * @param {number} [latitude] Latitude du contrôle.
     * @param {number} [longitude] Longitude du contrôle.
     * @param {number} [accuracy] Précision du contrôle en mètres. Cette valeur peut être arbitraire, elle permet de récupérer les tickets sur des zones voisines lorsque le contrôle est effectué sur une frontière.
     * @param {string} [scandate] Date du contrôle (ISO 8601). Si la valeur n\&#39;est pas spécifiée, la date courante est appliquée.
     * @param {'PDA' | 'IMAGE_REVIEW' | 'LAPI'} [terminalType] 
     * @param {string} [matricule] 
     * @param {string} [requestSrc] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TicketApiInterface
     */
    getTicketControl(cityId: string, licensePlate: string, latitude?: number, longitude?: number, accuracy?: number, scandate?: string, terminalType?: 'PDA' | 'IMAGE_REVIEW' | 'LAPI', matricule?: string, requestSrc?: string, options?: AxiosRequestConfig): AxiosPromise<TicketVerifyResult>;

    /**
     * Les droits necessaires dans le JWT sont &#58; <ul> <il><b>API_DISPATCHER_TICKET_WRITE</b></il> </ul>
     * @summary Sauvegarde d\'un ou plusieurs ticket
     * @param {string} cityId siret de la ville
     * @param {Docs} body 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof TicketApiInterface
     */
    insertTicket(cityId: string, body: Docs, options?: AxiosRequestConfig): AxiosPromise<Docs>;

    /**
     * Les droits necessaires dans le JWT sont &#58; <ul> <il><b>API_DISPATCHER_TICKET_WRITE</b></il> </ul>
     * @summary Mise à jour d\'un ou plusieurs tickets
     * @param {string} cityId siret de la ville
     * @param {Docs} body 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof TicketApiInterface
     */
    updateTicket(cityId: string, body: Docs, options?: AxiosRequestConfig): AxiosPromise<void>;

}

/**
 * TicketApi - object-oriented interface
 * @export
 * @class TicketApi
 * @extends {BaseAPI}
 */
export class TicketApi extends BaseAPI implements TicketApiInterface {
    /**
     * La route permet d\'effectuer un contrôle de stationnement. La route retourne la validité du droit dans le champ status, ainsi que la liste des tickets pertinent dans le cadre du contrôle.<br/> Dans le cas ou le droit est valide, le champ status prend la valeur VALID, et les tickets justifiant le droit sont retournés.<br/> Dans le cas ou le droit est invalide, le champ status prend la valeur INVALID. La route peut également renvoyer les tickets qui seront utilisés dans le cadre du calcul du montant du FPS lors de la verbalisation.<br/> Les droits necessaires dans le JWT sont  &#58; <ul> <il><b>ROLE_TICKETS_VERIFY</b></il> </ul>
     * @summary Controle de stationnement.
     * @param {string} cityId siret de la ville
     * @param {string} licensePlate Plaque d\&#39;immatriculation sur laquelle effectuer le contrôle.
     * @param {number} [latitude] Latitude du contrôle.
     * @param {number} [longitude] Longitude du contrôle.
     * @param {number} [accuracy] Précision du contrôle en mètres. Cette valeur peut être arbitraire, elle permet de récupérer les tickets sur des zones voisines lorsque le contrôle est effectué sur une frontière.
     * @param {string} [scandate] Date du contrôle (ISO 8601). Si la valeur n\&#39;est pas spécifiée, la date courante est appliquée.
     * @param {'PDA' | 'IMAGE_REVIEW' | 'LAPI'} [terminalType] 
     * @param {string} [matricule] 
     * @param {string} [requestSrc] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TicketApi
     */
    public getTicketControl(cityId: string, licensePlate: string, latitude?: number, longitude?: number, accuracy?: number, scandate?: string, terminalType?: 'PDA' | 'IMAGE_REVIEW' | 'LAPI', matricule?: string, requestSrc?: string, options?: AxiosRequestConfig) {
        return TicketApiFp(this.configuration).getTicketControl(cityId, licensePlate, latitude, longitude, accuracy, scandate, terminalType, matricule, requestSrc, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Les droits necessaires dans le JWT sont &#58; <ul> <il><b>API_DISPATCHER_TICKET_WRITE</b></il> </ul>
     * @summary Sauvegarde d\'un ou plusieurs ticket
     * @param {string} cityId siret de la ville
     * @param {Docs} body 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof TicketApi
     */
    public insertTicket(cityId: string, body: Docs, options?: AxiosRequestConfig) {
        return TicketApiFp(this.configuration).insertTicket(cityId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Les droits necessaires dans le JWT sont &#58; <ul> <il><b>API_DISPATCHER_TICKET_WRITE</b></il> </ul>
     * @summary Mise à jour d\'un ou plusieurs tickets
     * @param {string} cityId siret de la ville
     * @param {Docs} body 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof TicketApi
     */
    public updateTicket(cityId: string, body: Docs, options?: AxiosRequestConfig) {
        return TicketApiFp(this.configuration).updateTicket(cityId, body, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * WhitelistApi - axios parameter creator
 * @export
 */
export const WhitelistApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Les droits necessaires dans le JWT sont &#58; à déterminer (la route n\'a pas été testée)
         * @summary Ajout d\'une plaque d\'immatricuation dans la liste blanche
         * @param {string} cityId siret de la ville
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        consultWhitelist: async (cityId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cityId' is not null or undefined
            assertParamExists('consultWhitelist', 'cityId', cityId)
            const localVarPath = `/{cityId}/whitelist`
                .replace(`{${"cityId"}}`, encodeURIComponent(String(cityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-bearer-token", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Les droits necessaires dans le JWT sont &#58; à déterminer (la route n\'a pas été testée)
         * @summary Suppression d\'une plaque d\'immatricuation dans la liste blanche
         * @param {string} cityId siret de la ville
         * @param {WhitelistDeleteReq} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWhitelist: async (cityId: string, body: WhitelistDeleteReq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cityId' is not null or undefined
            assertParamExists('deleteWhitelist', 'cityId', cityId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('deleteWhitelist', 'body', body)
            const localVarPath = `/{cityId}/whitelist`
                .replace(`{${"cityId"}}`, encodeURIComponent(String(cityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-bearer-token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Les droits necessaires dans le JWT sont &#58; à déterminer (la route n\'a pas été testée)
         * @summary Ajout d\'une plaque d\'immatricuation dans la liste blanche
         * @param {string} cityId siret de la ville
         * @param {string} id id de l\&#39;entrée à ajouter
         * @param {WhitelistEntry} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insertWhitelist: async (cityId: string, id: string, body: WhitelistEntry, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cityId' is not null or undefined
            assertParamExists('insertWhitelist', 'cityId', cityId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('insertWhitelist', 'id', id)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('insertWhitelist', 'body', body)
            const localVarPath = `/{cityId}/whitelist`
                .replace(`{${"cityId"}}`, encodeURIComponent(String(cityId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-bearer-token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Les droits necessaires dans le JWT sont &#58; à déterminer (la route n\'a pas été testée)
         * @summary Mise à jour d\'une plaque d\'immatricuation dans la liste blanche
         * @param {string} cityId siret de la ville
         * @param {string} id id de l\&#39;entrée à supprimer
         * @param {WhitelistUpdateReq} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWhitelist: async (cityId: string, id: string, body: WhitelistUpdateReq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cityId' is not null or undefined
            assertParamExists('updateWhitelist', 'cityId', cityId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateWhitelist', 'id', id)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('updateWhitelist', 'body', body)
            const localVarPath = `/{cityId}/whitelist`
                .replace(`{${"cityId"}}`, encodeURIComponent(String(cityId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-bearer-token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WhitelistApi - functional programming interface
 * @export
 */
export const WhitelistApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WhitelistApiAxiosParamCreator(configuration)
    return {
        /**
         * Les droits necessaires dans le JWT sont &#58; à déterminer (la route n\'a pas été testée)
         * @summary Ajout d\'une plaque d\'immatricuation dans la liste blanche
         * @param {string} cityId siret de la ville
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async consultWhitelist(cityId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Ticket>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.consultWhitelist(cityId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Les droits necessaires dans le JWT sont &#58; à déterminer (la route n\'a pas été testée)
         * @summary Suppression d\'une plaque d\'immatricuation dans la liste blanche
         * @param {string} cityId siret de la ville
         * @param {WhitelistDeleteReq} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteWhitelist(cityId: string, body: WhitelistDeleteReq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WhitelistDeleteRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteWhitelist(cityId, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Les droits necessaires dans le JWT sont &#58; à déterminer (la route n\'a pas été testée)
         * @summary Ajout d\'une plaque d\'immatricuation dans la liste blanche
         * @param {string} cityId siret de la ville
         * @param {string} id id de l\&#39;entrée à ajouter
         * @param {WhitelistEntry} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async insertWhitelist(cityId: string, id: string, body: WhitelistEntry, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.insertWhitelist(cityId, id, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Les droits necessaires dans le JWT sont &#58; à déterminer (la route n\'a pas été testée)
         * @summary Mise à jour d\'une plaque d\'immatricuation dans la liste blanche
         * @param {string} cityId siret de la ville
         * @param {string} id id de l\&#39;entrée à supprimer
         * @param {WhitelistUpdateReq} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateWhitelist(cityId: string, id: string, body: WhitelistUpdateReq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WhitelistUpdateRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateWhitelist(cityId, id, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * WhitelistApi - factory interface
 * @export
 */
export const WhitelistApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WhitelistApiFp(configuration)
    return {
        /**
         * Les droits necessaires dans le JWT sont &#58; à déterminer (la route n\'a pas été testée)
         * @summary Ajout d\'une plaque d\'immatricuation dans la liste blanche
         * @param {string} cityId siret de la ville
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        consultWhitelist(cityId: string, options?: any): AxiosPromise<Array<Ticket>> {
            return localVarFp.consultWhitelist(cityId, options).then((request) => request(axios, basePath));
        },
        /**
         * Les droits necessaires dans le JWT sont &#58; à déterminer (la route n\'a pas été testée)
         * @summary Suppression d\'une plaque d\'immatricuation dans la liste blanche
         * @param {string} cityId siret de la ville
         * @param {WhitelistDeleteReq} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWhitelist(cityId: string, body: WhitelistDeleteReq, options?: any): AxiosPromise<WhitelistDeleteRes> {
            return localVarFp.deleteWhitelist(cityId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * Les droits necessaires dans le JWT sont &#58; à déterminer (la route n\'a pas été testée)
         * @summary Ajout d\'une plaque d\'immatricuation dans la liste blanche
         * @param {string} cityId siret de la ville
         * @param {string} id id de l\&#39;entrée à ajouter
         * @param {WhitelistEntry} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insertWhitelist(cityId: string, id: string, body: WhitelistEntry, options?: any): AxiosPromise<void> {
            return localVarFp.insertWhitelist(cityId, id, body, options).then((request) => request(axios, basePath));
        },
        /**
         * Les droits necessaires dans le JWT sont &#58; à déterminer (la route n\'a pas été testée)
         * @summary Mise à jour d\'une plaque d\'immatricuation dans la liste blanche
         * @param {string} cityId siret de la ville
         * @param {string} id id de l\&#39;entrée à supprimer
         * @param {WhitelistUpdateReq} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWhitelist(cityId: string, id: string, body: WhitelistUpdateReq, options?: any): AxiosPromise<WhitelistUpdateRes> {
            return localVarFp.updateWhitelist(cityId, id, body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WhitelistApi - interface
 * @export
 * @interface WhitelistApi
 */
export interface WhitelistApiInterface {
    /**
     * Les droits necessaires dans le JWT sont &#58; à déterminer (la route n\'a pas été testée)
     * @summary Ajout d\'une plaque d\'immatricuation dans la liste blanche
     * @param {string} cityId siret de la ville
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WhitelistApiInterface
     */
    consultWhitelist(cityId: string, options?: AxiosRequestConfig): AxiosPromise<Array<Ticket>>;

    /**
     * Les droits necessaires dans le JWT sont &#58; à déterminer (la route n\'a pas été testée)
     * @summary Suppression d\'une plaque d\'immatricuation dans la liste blanche
     * @param {string} cityId siret de la ville
     * @param {WhitelistDeleteReq} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WhitelistApiInterface
     */
    deleteWhitelist(cityId: string, body: WhitelistDeleteReq, options?: AxiosRequestConfig): AxiosPromise<WhitelistDeleteRes>;

    /**
     * Les droits necessaires dans le JWT sont &#58; à déterminer (la route n\'a pas été testée)
     * @summary Ajout d\'une plaque d\'immatricuation dans la liste blanche
     * @param {string} cityId siret de la ville
     * @param {string} id id de l\&#39;entrée à ajouter
     * @param {WhitelistEntry} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WhitelistApiInterface
     */
    insertWhitelist(cityId: string, id: string, body: WhitelistEntry, options?: AxiosRequestConfig): AxiosPromise<void>;

    /**
     * Les droits necessaires dans le JWT sont &#58; à déterminer (la route n\'a pas été testée)
     * @summary Mise à jour d\'une plaque d\'immatricuation dans la liste blanche
     * @param {string} cityId siret de la ville
     * @param {string} id id de l\&#39;entrée à supprimer
     * @param {WhitelistUpdateReq} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WhitelistApiInterface
     */
    updateWhitelist(cityId: string, id: string, body: WhitelistUpdateReq, options?: AxiosRequestConfig): AxiosPromise<WhitelistUpdateRes>;

}

/**
 * WhitelistApi - object-oriented interface
 * @export
 * @class WhitelistApi
 * @extends {BaseAPI}
 */
export class WhitelistApi extends BaseAPI implements WhitelistApiInterface {
    /**
     * Les droits necessaires dans le JWT sont &#58; à déterminer (la route n\'a pas été testée)
     * @summary Ajout d\'une plaque d\'immatricuation dans la liste blanche
     * @param {string} cityId siret de la ville
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WhitelistApi
     */
    public consultWhitelist(cityId: string, options?: AxiosRequestConfig) {
        return WhitelistApiFp(this.configuration).consultWhitelist(cityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Les droits necessaires dans le JWT sont &#58; à déterminer (la route n\'a pas été testée)
     * @summary Suppression d\'une plaque d\'immatricuation dans la liste blanche
     * @param {string} cityId siret de la ville
     * @param {WhitelistDeleteReq} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WhitelistApi
     */
    public deleteWhitelist(cityId: string, body: WhitelistDeleteReq, options?: AxiosRequestConfig) {
        return WhitelistApiFp(this.configuration).deleteWhitelist(cityId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Les droits necessaires dans le JWT sont &#58; à déterminer (la route n\'a pas été testée)
     * @summary Ajout d\'une plaque d\'immatricuation dans la liste blanche
     * @param {string} cityId siret de la ville
     * @param {string} id id de l\&#39;entrée à ajouter
     * @param {WhitelistEntry} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WhitelistApi
     */
    public insertWhitelist(cityId: string, id: string, body: WhitelistEntry, options?: AxiosRequestConfig) {
        return WhitelistApiFp(this.configuration).insertWhitelist(cityId, id, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Les droits necessaires dans le JWT sont &#58; à déterminer (la route n\'a pas été testée)
     * @summary Mise à jour d\'une plaque d\'immatricuation dans la liste blanche
     * @param {string} cityId siret de la ville
     * @param {string} id id de l\&#39;entrée à supprimer
     * @param {WhitelistUpdateReq} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WhitelistApi
     */
    public updateWhitelist(cityId: string, id: string, body: WhitelistUpdateReq, options?: AxiosRequestConfig) {
        return WhitelistApiFp(this.configuration).updateWhitelist(cityId, id, body, options).then((request) => request(this.axios, this.basePath));
    }
}


